import { gql } from '@apollo/client'

const followedArtistFragment = gql`
  fragment followedArtists on ArtistConnection {
    edges {
      node {
        id
        avatar
      }
    }
  }
`

export default followedArtistFragment
